import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'

import * as qs from 'query-string'
import Moment from 'react-moment'
import { Table, Button, ButtonGroup } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Breadcrumbs from '../Breadcrumbs.component'
import EmployeeCard from './components/EmployeeCard.component'

import { EmployeesState } from 'src/store/employees/reducer'

import { fetchEmployees, setCurrentEmployee } from '../../store/employees/actions'
import { Employee, EmployeeFilterParams } from '../../lib/interfaces/Employee.interface'
import { employmentStatusToString } from 'src/lib/interfaces/EmploymentStatus.interface'

import { formatName } from '../../lib/helpers/format'

const get = require('lodash/get')
const map = require('lodash/map')
const isEmpty = require('lodash/isEmpty')

type EmployeeListViewMode = 'card' | 'table'

export interface EmployeeListState {
  viewMode: EmployeeListViewMode
  pageStatus: 'loading' | 'done'
  filterParams: EmployeeFilterParams
}

export interface EmployeeListProps extends RouteComponentProps {
  employees?: Employee[]
  setCurrentEmployee: (employee: Employee) => void
  fetchEmployees: (filterParams: EmployeeFilterParams) => void
}

class EmployeeListPage extends React.Component<EmployeeListProps, EmployeeListState> {
  constructor(props: EmployeeListProps) {
    super(props)

    const filterParams: EmployeeFilterParams = this.extractFilterParams(props)
    this.state = {
      filterParams,
      viewMode: 'table',
      pageStatus: 'loading'
    }
  }

  componentDidMount() {
    const { filterParams } = this.state

    if (filterParams.search || filterParams.location) {
      this.setState({ pageStatus: 'loading' }, () => {
        this.props.fetchEmployees(filterParams)
      })
    }
    else {
      this.setState({ pageStatus: 'done' })
    }
  }

  componentDidUpdate(prevProps: EmployeeListProps) {
    if (this.props.employees && this.props.employees !== prevProps.employees) {
      this.setState(() => ({ pageStatus: 'done' }))
    }

    const filterParams = this.extractFilterParams(this.props)
    const { search: oldSearch, location: oldLocation } = this.extractFilterParams(prevProps)

    if (filterParams.search !== oldSearch || filterParams.location !== oldLocation) {
      this.setState(
        { filterParams},
        () => this.props.fetchEmployees(filterParams)
      )
    }
  }

  extractFilterParams(props: EmployeeListProps) {
    const search = get(props, 'location.search')
    const params = qs.parse(search)

    const filterParams: EmployeeFilterParams = {
      search: params.search as any
    }

    if (params.location) {
      filterParams.location = parseInt(params.location as any, 10)
    }

    return filterParams
  }

  handleSetCurrentEmployee(e: React.MouseEvent<HTMLElement>, employee: Employee) {
    e.preventDefault()
    this.props.setCurrentEmployee(employee)
  }

  // singleSelectFilterChanged(propertyName: string, selectedOption: ValueType<any>) {
  //   // this.updateStateFromFilterChange(propertyName, selectedOption.value)
  // }

  render() {
    const { employees } = this.props
    const { viewMode, pageStatus, filterParams } = this.state

    if (pageStatus === 'loading') {
      return (
        <div className="p-3">Loading...</div>
      )
    }
    else if (isEmpty(filterParams.search) && !filterParams.location) {
      return (
        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center pb-5">
          <FontAwesomeIcon
            color="#505051"
            icon={['fas', 'search']}
            style={{ fontSize: '120px' }}
          />

          <h2 className="mt-3" style={{ color: '#505051' }}>Search...</h2>
        </div>
      )
    }
    else if (isEmpty(employees)) {
      return (
        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center pb-5">
          <FontAwesomeIcon
            color="#505051"
            icon={['far', 'folder-open']}
            style={{ fontSize: '150px' }}
          />

          <h2 className="mt-3" style={{ color: '#505051' }}>No results...</h2>
        </div>
      )
    }

    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Dashboard', link: '/dashboard' },
          { name: 'Employees', active: true },
        ]} />
        <div className="page">
          <div className="d-flex align-items-center mb-3">
            <h5 className="title mb-0">Employees</h5>

            <ButtonGroup className="ml-3">
              <Button
                outline
                size="sm"
                className="ggbutton"
                active={viewMode === 'table'}
                onClick={() => this.setState({ viewMode: 'table' })}
                color={viewMode === 'table' ? 'primary' : 'secondary'}
              >
                <FontAwesomeIcon icon={['fas', 'list']} />
              </Button>
              <Button
                outline
                size="sm"
                className="ggbutton"
                active={viewMode === 'card'}
                onClick={() => this.setState({ viewMode: 'card' })}
                color={viewMode === 'card' ? 'primary' : 'secondary'}
              >
                <FontAwesomeIcon icon={['fas', 'box']} />
              </Button>
            </ButtonGroup>
          </div>
          <div className="row">
            <div className="col-4">
              {/* <LocationSelect value={filterParams.location} onChange={value => this.handleLocationChange(value)} /> */}
              {/* <div className="dropdown"> */}
                {/* <button className="btn btn-white dropdown-toggle"> */}
                  {/* Filter by Location */}
                {/* </button>                 */}
              {/* </div> */}
            </div>
            {/* <div className="col-4">
              <div className="dropdown" style={{width: '300px'}}>
                <button className="btn btn-white dropdown-toggle">
                  Filter by Intent
                </button>
              </div>
            </div> */}

            {/* <div className="col-4">
              <div className="dropdown">
                <button className="btn btn-white dropdown-toggle">
                  Filter by Reasn
                </button>
              </div>
            </div> */}

          </div>

          {viewMode === 'card'
            ? (
              <div className="row">
                {(map(employees, employee => (
                  <div key={employee.id} className="col-sm-12 col-md-6 col-lg-4">
                    <EmployeeCard employee={employee} onSelectEmployee={this.props.setCurrentEmployee} />
                    <br/>
                  </div>
                )))}
              </div>
            )
            : (
              <Table hover className="table table-striped">
                <thead>
                  <tr>
                    <td className="font-weight-bold px-2 py-2">ID</td>
                    <td className="font-weight-bold px-2 py-2">Name</td>
                    <td className="font-weight-bold px-2 py-2">Status</td>
                    <td className="font-weight-bold px-2 py-2">Hire date</td>
                    <td className="text-right font-weight-bold px-2 py-2">Gender</td>
                  </tr>
                </thead>
                <tbody>
                  {map(employees, employee => (
                    <tr
                      key={employee.id}
                      className="cursor-pointer"
                      onClick={() => this.props.history.push(`/employees/${employee.id}`)}
                    >
                      <td className="px-2">{employee.id}</td>
                      <td className="px-2">{formatName(employee)}</td>
                      <td className="px-2">{employmentStatusToString(employee.employmentStatus) || '-'}</td>
                      <td className="px-2">{employee.hireDate ? <Moment date={employee.hireDate} format="MM.DD.YYYY" /> : '-'}</td>
                      <td className="text-right px-2">{employee.gender || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ employees, app }: { employees: EmployeesState, app: any }) => ({
  employees: employees.employees
})

const mapDispatchToProps = (dispatch) => ({
  fetchEmployees: filterParams => dispatch(fetchEmployees(filterParams)),
  setCurrentEmployee: (employee: Employee) => dispatch(setCurrentEmployee(employee))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmployeeListPage))



// WEBPACK FOOTER //
// ./src/routes/employees/EmployeeList.page.tsx